"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseOrderType = void 0;
var WarehouseOrderType;
(function (WarehouseOrderType) {
    WarehouseOrderType["REMOVAL"] = "REMOVAL";
    WarehouseOrderType["LIQUIDATION"] = "LIQUIDATION";
    WarehouseOrderType["CONSOLIDATION"] = "CONSOLIDATION";
    WarehouseOrderType["TRANSFER"] = "TRANSFER";
    WarehouseOrderType["DISPOSAL"] = "DISPOSAL";
    WarehouseOrderType["FULFILLMENT"] = "FULFILLMENT";
    WarehouseOrderType["WHOLESALE"] = "WHOLESALE";
    WarehouseOrderType["TEST"] = "TEST";
    WarehouseOrderType["FORWARDING"] = "FORWARDING";
    WarehouseOrderType["B2B_PREP"] = "B2B_PREP";
    WarehouseOrderType["FWD_PREP"] = "FWD_PREP";
    WarehouseOrderType["EACH_PICK_ORDER"] = "EACH_PICK_ORDER";
    WarehouseOrderType["ECOM_PREP"] = "ECOM_PREP";
})(WarehouseOrderType = exports.WarehouseOrderType || (exports.WarehouseOrderType = {}));
//# sourceMappingURL=WarehouseOrder.js.map